import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  nextPage: '',
};


const appRouteSlice = createSlice({
  name: 'appRoute',
  initialState,
  reducers: {
    setNextPage: (state, action) => {
      state.nextPage = action.payload;
    },
  },
});

export const {
  setNextPage
} = appRouteSlice.actions;

export default appRouteSlice.reducer;